module.exports = __webpack_public_path__ + "img/39.bcb108ad.jpg";